import type { CanvasTarget, WorkspaceView } from '../types';

/**
 * An App is never a panel beside a page: opened from the Apps place (or a shared link into it) a saved App is its own
 * page, with minimal chrome (operator 07:20, DES1 spec 5). The Artifact canvas on the Apps view is that page.
 */
export const isAppPageMode = (view: WorkspaceView, canvas: CanvasTarget | null | undefined) =>
  view === 'apps' && canvas?.kind === 'artifact';
